<template>
  <div class="custom-main custom-theme chat-application" style="background: #f8f8fa;">
    <a-spin :spinning="loading" tip="正在加载远程辅诊信息,请稍候...">
      <div v-if="trtc">
        <vue-drag-resize  :w="800" :h="450" :minw="400" :minh="225" :x="drag.left" :y="drag.top" :z="99999" :aspect-ratio="true" @resizing="resize"  :style="{'border':'#91d5ff solid 1px'}">
          <div id="localStream" class="room-video-bg-img" :style="{'z-index':(videoType == '1' ? '999':'0'),'right': '3px','bottom':'3px','position':'absolute','width': (videoType == '1' ? drag.vw*0.3 : drag.vw ) + 'px','height':  (videoType == '1' ? drag.vh*0.3 : drag.vh ) + 'px'}">
          </div>
          <div id="remoteStream" width="100%" class="room-video-bg-img" :style="{'z-index':(videoType == '1' ? '0':'999'),'right': '3px','bottom':'3px','position':'absolute','width': (videoType == '1' ? drag.vw : drag.vw*0.3 ) + 'px','height':  (videoType == '1' ? drag.vh : drag.vh*0.3 ) + 'px'}">
          </div>
          <a-button icon="fullscreen" title="全屏" size="large" @click="videoChange" :style="{'z-index':'1000','position':'absolute','right': '3px','bottom': '5px', 'width': '24px','height': '24px','background': '#e7eff3','color':'#fe6e6e','margin-right':'10px','border': 'none'}"/>
        </vue-drag-resize>
      </div>
      <a-row>
        <a-col :xxl="16" :xl="16" :lg="16" :md="24" :sm="24" :xs="24">
          <a-card size="small" :head-style="{'borderBottom':'none', 'background':'rgba(236, 243, 246, 0.8)', 'paddingLeft':'24px', 'paddingRight':'24px'}"
                  :body-style="{'padding':'0px', 'paddingLeft':'24px', 'paddingRight':'24px','minHeight': 'calc(100vh - 206px)'}">
            <span slot="title" class="gpws-model-title" style="font-size: 19px;color: rgba(26, 133, 180, 0.9);">
              <a-row>
                <a-col span="12">
                  <img src="../../../assets/img/split.png" style="line-height:21px;margin-right: 9px;user-select: none;"/>远程辅诊
                </a-col>
                <a-col span="12">
                  <img src="../../../assets/img/end.png" style="float: right;line-height:21px;margin-right: 9px; cursor:pointer;user-select: none;" @click="endAction"/>
                  <img src="../../../assets/img/v-m.png" v-if="(record.type =='SUBSEQUENT_VISIT')" style="float: right;line-height:21px;margin-right: 9px; cursor:pointer;user-select: none;" @click="archiveDrawer()"/>
                                                    <img src="../../../assets/img/v-d.png" style="float: right;line-height:21px;margin-right: 9px; cursor:pointer;user-select: none;" @click="detailAction"/>
                </a-col>
              </a-row>
            </span>
            <a-card size="small" :bordered="false"
                    :head-style="{'borderBottom':'none', 'paddingLeft':'24px', 'paddingRight':'24px'}"
                    :body-style="{'padding':'0px', 'paddingLeft':'24px', 'paddingRight':'24px'}">
              <span slot="title" class="gpws-menu-title" style="font-size: 16px;font-family: Alibaba PuHuiTi;">
                  <img src="../../../assets/img/peoples.png"
                       style="width:22px;height: 18px; margin-right: 9px;user-select: none;"/>辅诊关联方
              </span>
              <a-row style="margin-bottom: 10px;">
                <a-col span="6">
                  <div style="color: #6A6A6A; display: flex;flex-direction: row;align-items: center"><img src="../../../assets/img/times.png"
                                                                                                          style="width:16px;height: 16px;user-select: none;"/>预约时间</div>
                  <div>{{record.visitDate}}&nbsp;{{record.startTime}}-{{record.endTime}}</div>
                </a-col>
                <a-col span="18">
                  <div style="color: #6A6A6A; display: flex;flex-direction: row;align-items: center"><img src="../../../assets/img/times.png"
                                                                                                          style="width:16px;height: 16px;user-select: none;"/>申请时间</div>
                  <div>{{record.applyTime}}</div>
                </a-col>
              </a-row>
              <a-row style="margin-bottom: 12px;">
                <a-col span="6">
                  <div style="width: 200px;height: 70px;background: #F5F5E7;border-radius: 8px;">
                    <a-col span="8" style="padding: 5px 8px;">
                      <a-avatar style="background-color: rgb(135, 208, 104);" :size="56" icon="user" />
                    </a-col>
                    <a-col span="16">
                      <div style="line-height:20px;font-size: 13px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #606060;">
                        发起方
                      </div>
                      <div style="line-height:25px;font-size: 16px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #222222;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                        {{record.doctor}}&nbsp;<span style="font-size: 14px;">{{record.department}}</span>
                      </div>
                      <div style="line-height:25px;font-size: 14px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #222222;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                        {{record.organ}}
                      </div>
                    </a-col>
                  </div>
                </a-col>
                <a-col span="18">
                  <div style="width: 200px;height: 70px;background: rgba(226, 239, 255, 0.86);border-radius: 8px;">
                    <a-col span="8"  style="padding: 5px 8px;">
                      <a-avatar :size="56" :src="doctorAvater" />
                    </a-col>
                    <a-col span="16">
                      <div style="line-height:20px;font-size: 13px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #606060;">
                        受邀方
                      </div>
                      <div style="line-height:25px;font-size: 16px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #222222;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                        {{record.expert}}&nbsp;<span style="font-size: 14px;">{{record.expertDepart}}</span>
                      </div>
                      <div style="line-height:25px;font-size: 14px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #222222;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                        {{record.expertOrgan}}
                      </div>
                    </a-col>
                  </div>
                </a-col>
              </a-row>
            </a-card>
            <a-card size="small" :bordered="false"
                    :head-style="{'borderBottom':'none', 'paddingLeft':'24px', 'paddingRight':'24px'}"
                    :body-style="{'padding':'0px', 'paddingLeft':'24px', 'paddingRight':'24px'}">
              <span slot="title" class="gpws-menu-title" style="font-size: 16px;font-family: Alibaba PuHuiTi;">
                <img src="../../../assets/img/split.png" style="margin-right: 9px;user-select: none;"/>患者信息
              </span>
              <a-row style="margin-bottom: 12px;">
                <a-col span="6">
                  <div style="width: 200px;height: 70px;background: #F5F5E7;border-radius: 8px; display: flex;flex-direction: row;align-items: center">
                    <a-col span="8" style="text-align: center;padding: 5px 8px;">
                      <a-avatar style="background-color: #e8e8e8;" :size="56" icon="user" />
                    </a-col>
                    <a-col span="16">
                      <div style="line-height:20px;font-size: 13px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #606060;">
                        患者
                      </div>
                      <div style="line-height:30px;font-size: 16px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #222222;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                        {{record.name}}
                      </div>
                    </a-col>
                  </div>
                </a-col>
                <a-col span="18">
                  <a-row style="line-height: 25px;">
                    <a-col span="5">性别:<span style="font-weight: 300;color:#222222">{{record.sexName}}</span></a-col>
                    <a-col span="5">年龄:<span style="font-weight: 300;color:#222222">{{record.age}}</span></a-col>
                    <a-col span="5">孕否:<span style="font-weight: 300;color:#222222">{{record.gestate?'是':'否'}}</span></a-col>
                    <a-col span="9">联系电话:<span style="font-weight: 300;color:#222222">{{record.phone}}</span></a-col>
                  </a-row>
                  <a-row style="line-height: 25px;">
                    <a-col>初步诊断:<span style="color:#222222">{{record.diagnostic}}</span></a-col>
                  </a-row>
                </a-col>
              </a-row>
            </a-card>
            <a-card v-if="record.existed" size="small"  :bordered="false" :head-style="{'borderBottom':'none', 'paddingLeft':'24px', 'paddingRight':'24px'}" :body-style="{'padding':'0px'}">
              <span slot="title" class="gpws-menu-title" style="font-size: 16px;font-family: Alibaba PuHuiTi;">
                <img src="../../../assets/img/split.png" style="margin-right: 9px;user-select: none;"/>病历资料
              </span>
              <a-row v-if="(record.medical.complaint||'') != ''">
                <a-col>
                  <a-form-item label="主诉" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                    {{ record.medical.complaint }}
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row v-if="(record.medical.currHistory||'') != ''">
                <a-col>
                  <a-form-item label="现病史" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                    {{ record.medical.currHistory }}
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row v-if="(record.medical.allergyHistory||'') != ''">
                <a-col>
                  <a-form-item label="过敏史" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                    {{ record.medical.allergyHistory }}
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row v-if="(record.medical.auxiliary||'') != ''">
                <a-col>
                  <a-form-item label="辅助检查" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                    {{ record.medical.auxiliary }}
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row v-if="(record.medical.laboratory||'') != ''">
                <a-col>
                  <a-form-item label="临床检验" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                    {{ record.medical.laboratory }}
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col>
                  <a-form-item label="体格检查" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                    <a-row>
                      <a-col v-if="record.medical.physical.height" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                        <a-form-item label="身高" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                          {{record.medical.physical.height }} CM
                        </a-form-item>
                      </a-col>
                      <a-col v-if="record.medical.physical.weight" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                        <a-form-item label="体重" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                          {{record.medical.physical.weight }} KG
                        </a-form-item>
                      </a-col>
                      <a-col v-if="record.medical.physical.pulse" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                        <a-form-item label="脉搏" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                          {{record.medical.physical.pulse }} 次/分钟
                        </a-form-item>
                      </a-col>
                      <a-col v-if="record.medical.physical.hr" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                        <a-form-item label="心率" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                          {{record.medical.physical.hr }} 次/分钟
                        </a-form-item>
                      </a-col>
                      <a-col v-if="record.medical.physical.temperature" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                        <a-form-item label="体温" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                          {{record.medical.physical.temperature }} ℃
                        </a-form-item>
                      </a-col>
                      <a-col v-if="record.medical.physical.sbp || record.medical.physical.dbp" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                        <a-form-item label="血压" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                          {{record.medical.physical.sbp }} mmHg/{{record.medical.physical.dbp }}mmHg
                        </a-form-item>
                      </a-col>
                      <a-col v-if="record.medical.physical.glu" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                        <a-form-item label="血糖" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                          {{record.medical.physical.glu }} mmol/L
                        </a-form-item>
                      </a-col>
                      <a-col v-if="record.medical.physical.breath" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                        <a-form-item label="呼吸" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                          {{record.medical.physical.breath }} 次/分钟
                        </a-form-item>
                      </a-col>
                    </a-row>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row v-if="(record.medical.pastHistory||'') != ''">
                <a-col>
                  <a-form-item label="既往史" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                    {{ record.medical.pastHistory }}
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row v-if="(record.medical.selfHistory||'') != ''">
                <a-col>
                  <a-form-item label="个人史" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                    {{ record.medical.selfHistory }}
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row v-if="(record.medical.familyHistory||'') != ''">
                <a-col>
                  <a-form-item label="家族史" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                    {{ record.medical.familyHistory }}
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row v-if="(record.medical.otherHistory||'') != ''">
                <a-col>
                  <a-form-item label="其它病史" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                    {{ record.medical.otherHistory }}
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row v-if="(record.medical.symptom||'') != ''">
                <a-col>
                  <a-form-item label="望闻问切" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                    {{ record.medical.symptom }}
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row v-if="(pics||[]).length > 0">
                <a-col>
                  <a-form-item label="症状图片" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                    <img v-for="(item, index) in (pics||[])" :src="item.url" :key="'img-'+(index+1)" class="img" @click="showFullImg(item.url)">
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row v-if="(annexes||[]).filter(m => m.type == 'CHECK_RESULT').length > 0">
                <a-col>
                  <a-form-item label="检查结果" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                    <img v-for="(item, index) in (annexes||[]).filter(m => m.type == 'CHECK_RESULT')" :src="item.pic.url" :key="'c-img-'+(index+1)" class="img" @click="showFullImg(item.pic.url)">
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row v-if="(annexes||[]).filter(m => m.type == 'INSPECT_RESULT').length > 0">
                <a-col>
                  <a-form-item label="检验结果" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                    <img v-for="(item, index) in (annexes||[]).filter(m => m.type == 'INSPECT_RESULT')" :src="item.pic.url" :key="'i-img-'+(index+1)" class="img" @click="showFullImg(item.pic.url)">
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row v-if="(annexes||[]).filter(m => m.type == 'MEDICAL').length > 0">
                <a-col>
                  <a-form-item label="病历资料" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                    <img v-for="(item, index) in (annexes||[]).filter(m => m.type == 'MEDICAL')" :src="item.pic.url" :key="'m-img-'+(index+1)" class="img" @click="showFullImg(item.pic.url)">
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row v-if="(annexes||[]).filter(m => m.type == 'PHYSICAL').length > 0">
                <a-col>
                  <a-form-item label="体检报告" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                    <img v-for="(item, index) in (annexes||[]).filter(m => m.type == 'PHYSICAL')" :src="item.pic.url" :key="'p-img-'+(index+1)" class="img" @click="showFullImg(item.pic.url)">
                  </a-form-item>
                </a-col>
              </a-row>
            </a-card>
          </a-card>
        </a-col>
        <a-col :xxl="8" :xl="8" :lg="8" :md="24" :sm="24" :xs="24">
          <a-card size="small" class="app-chat chat" :head-style="{'borderBottom':'none', 'height' : '60px', 'background':'rgba(236, 243, 246, 0.8)', 'paddingLeft':'24px', 'paddingRight':'24px'}"
                  :body-style="{'padding':'0px', 'minHeight':'290px'}">
            <span slot="title" class="gpws-model-title" style="font-size: 19px;color: rgba(26, 133, 180, 0.9);">
              <a-row>
                <a-col span="3">
                  <a-avatar style="background-color: rgb(135, 208, 104);" :size="46" :src="doctorAvater" />
                </a-col>
                <a-col span="21">
                  <div style="line-height:25px;font-size: 16px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #222222;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;"> {{record.expert}}&nbsp;<span style="font-size: 14px;">{{record.expertDepart}}</span> </div>
                  <div style="line-height:20px;font-size: 13px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #606060;">{{ record.expertOrgan }}</div>
                </a-col>
              </a-row>
            </span>
            <div class="chat-content" style="background-color: rgba(251, 251, 251, 0.5);">
              <div ref="chats" class="chat-area" style="background-color: rgba(251, 251, 251, 0.5);border:none;height: calc(100vh - 440px);">
                <div class="chats">
                  <div v-for="(chat, index) in chats" :key="'c-'+index" :class="chat.sender == 'I'?'chat chat-right':'chat'">
                    <div class="chat-avatar">
                      <a class="avatar">
                        <a-avatar v-if="chat.sender == 'U'" :src="doctorAvater" />
                        <a-avatar v-else style="background-color: rgb(135, 208, 104);" icon="user" />
                      </a>
                    </div>
                    <div class="chat-body">
                      <div v-for="(m, i) in chat.messages" :key="'m-'+index+'-'+ i" :class="m.type=='audio'?'chat-audio':'chat-text'">
                        <p v-if="m.type=='text'">{{m.message}}</p>
                        <p v-if="m.type=='image'" style="padding: .15rem .2rem .15rem .15rem;">
                          <img :src="m.message" style="width:100%;height: auto;cursor: pointer; background-color: white;" @click="showFullImg(m.message)"/>
                        </p>
                        <a-audio v-if="m.type=='audio'" :src="m.message"></a-audio>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="border-radius: 4px;">
              <div class="chat-tool" style="background:#ffffff;height: 34px;">
                <span style="padding-right: 20px;line-height: 34px;">
                  <a-upload accept="image/*" :show-upload-list="false" :before-upload="beforeUpload" :custom-request="handleImgUpload">
                    <a-button icon="file-image" title="发送图片" style="margin-left:6px;width: 32px;height: 32px;color: #2196f3;border: none;"/>
                  </a-upload>
                  <a-button icon="audio" title="发送录音" @click="onAudioModalAction" style="margin-left:6px;width: 32px;height: 32px;color: #2196f3;border: none;"/>
                </span>
              </div>
              <a-textarea v-model="message" :rows="5" style="border: #d9d9d9 solid 0px;" placeholder="请在此输入" ref="send" @keyup.ctrl.enter="sendMeg"></a-textarea>
            </div>
            <div style="text-align: center;margin-top:10px;">
              <img src="../../../assets/img/send.png" style="cursor: pointer;user-select: none;" @click="sendMeg"/>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </a-spin>
    <a-modal :title="null" centered :visible="audio.visible" :footer="null" @cancel="audioCancelAction" width="350">
      <a-spin :spinning="audio.loading" tip="正在发送录音信息,请稍候....">
        <a-row>
          <a-col span="8"><a-button type="primary" :disabled="audio.isrecorder" @click="startRecorder">开始录音</a-button></a-col>
          <a-col span="8"><a-button type="danger" :disabled="!audio.isrecorder" @click="stopRecorder">结束录音</a-button></a-col>
          <a-col span="8" style="line-height: 32px;">录音时长:<span style="color: red;">{{ audio.duration }}</span>秒</a-col>
        </a-row>
        <a-row>
          <a-col span="24">
            <canvas id="canvas" style="height: 100px;width: 300px;margin-top: 10px;"></canvas>
          </a-col>
        </a-row>
      </a-spin>
    </a-modal>
    <outpatient-drawer ref="outpatientDrawer"/>
    <archive-drawer ref="archiveDrawer" v-if="record.type == 'SUBSEQUENT_VISIT'"/>
  </div>
</template>

<script>
  import Vue from 'vue'
  import TRTC from 'trtc-js-sdk';
  import global from '../../../api/global';
  import Recorder from 'js-audio-recorder';
  import lamejs from 'lamejs';
  import Audio from '@/components/base/Audio.vue';
  import doctorAvater from '@/assets/img/doctor-avater.png';
  import hevueImgPreview from 'hevue-img-preview';
  import VueDragResize from 'vue-drag-resize';
  Vue.use(hevueImgPreview);
  Vue.component('vue-drag-resize', VueDragResize);
  import ArchiveDrawer from '@/components/telemed/ArchiveDrawer.vue';
  import OutpatientDrawer from '@/components/outpatient/OutpatientDrawer.vue';
  export default {
    name: "DoctorRoom",
    components:{'a-audio':Audio, OutpatientDrawer, ArchiveDrawer},
    data(){
      return {
        loading:false,
        doctorAvater:doctorAvater,
        current:{},//当前医生
        message:'',
        image:'',
        socket:null,// websocket
        heartHandler:null,//心跳
        chats:[],//聊天消息
        record:{},
        annexes:[],
        pics:[],
        trtc:false,
        trtcClient:null,//视频句柄
        localStream:null,//本地音视频流句柄
        audio:{
          visible:false,
          loading:false,
          duration:0,
          isrecorder:false
        },
        recorder:null,

        videoType : '1',  //1-默认视频方式 对方大视频，本地小视频   2 对方小视频 播放大视频
        drawId:null,
        canvas:null,
        ctx:null,
        drag:{
          vw: 800,
          vh: 450,
          top: 60,
          left:10
        }
      }
    },
    beforeCreate() {
      let data = [{
        text: "首页",
        path: ""
      },{
        text: "门诊",
        path: ""
      },{
        text: "远程辅诊",
        path: ""
      }];
      this.$store.commit('updateBreadcrumb', data);
    },
    mounted() {
      let id = this.$route.query.id;
      this.current = JSON.parse(localStorage.getItem("curruser"));
      this.loadOutpatient(id);
      this.loadChats(id);
    },
    beforeDestroy() {
      if(undefined != this.socket && null != this.socket){
        this.socket.close();
      }
      this.destroyRecorder();
    },
    methods:{
      detailAction: function () {
        this.$refs.outpatientDrawer.showAction(this.record.id);
      },
      archiveDrawer:function (){
        this.$refs.archiveDrawer.showArchiveDrawer(this.record.patientId, 'TELEMEDICINE', this.record.expertOrganId, 'CLINIC');
      },
      startRecorder:function (){
        const self =this;
        Recorder.getPermission().then(
          () => {
            if(undefined == self.recorder || null == self.recorder){
              self.recorder = new Recorder({sampleBits: 16, sampleRate: 48000, numChannels: 1});
              self.recorder.onprogress = (params) => {
                self.audio.duration = params.duration.toFixed(0);
              }
            }
            self.recorder.start().then(() => {
              self.audio.isrecorder = true;
              self.canvas = document.getElementById('canvas');
              self.ctx = self.canvas.getContext('2d');
              self.drawCanvas();
            }, (error) => {
              self.$message.error(`${error.name} : ${error.message}`);
            });
          },
          (error) => {
            if(error.name == 'NotFoundError'){
              self.$message.error('请先接入麦克风.');
            } if(error.name == 'NotAllowedError'){
              self.$message.error('获取麦克风权限失败.');
            }else{
              self.$message.error(`${error.name} : ${error.message}`);
            }
          }
        );
      },
      stopRecorder:function (){
        const self = this;
        this.audio.loading=true;
        let mp3Blob = this.convertToMp3(this.recorder.getWAV());
        if(undefined != mp3Blob && null != mp3Blob){
          let file = new File([mp3Blob], 'recorder.mp3');
          let params = new FormData();
          params.append("file", file);
          this.destroyRecorder();
          this.$axios.post('/api/dmz/CHAT/file/upload', params, {headers: {
              'Content-Type': 'multipart/form-data'
            },timeout: 1000 * 60 * 15}).then(function(res){
            self.audio.loading=false;
            self.audio.isrecorder = false;
            if(res.msg.flag == 0){
              let meet={contentType:'audio/*', from:self.current.doctorId, nickname:self.current.name,
                to:self.record.expertId, body:res.biz.url, tid:self.current.tenantId, bizId:self.record.id};
              self.socket.send(JSON.stringify(meet));
              console.info("发送的消息内容："+JSON.stringify(meet));
              //添加消息
              self.audioCancelAction();
              self.appendMsg(self.record.id, 'I', 'audio', res.biz.url);
            }else{
              self.$message.error({content: res.msg.message, duration: 2});
            }
          },function(){
            self.audio.loading=false;
          });
        }
      },
      destroyRecorder:function() {
        const self = this;
        if (this.recorder) {
          this.recorder.destroy().then(() => {
            self.recorder = null;
            self.drawId && cancelAnimationFrame(self.drawId);
            self.drawId = null;
          });
        }
      },
      convertToMp3:function(wavDataView) {
      // 获取wav头信息
      const wav = lamejs.WavHeader.readHeader(wavDataView); // 此处其实可以不用去读wav头信息，毕竟有对应的config配置
      const { channels, sampleRate } = wav;
      const mp3enc = new lamejs.Mp3Encoder(channels, sampleRate, 128);
      // 获取左右通道数据
      const result = this.recorder.getChannelData()
      const buffer = [];

      const leftData = result.left && new Int16Array(result.left.buffer, 0, result.left.byteLength / 2);
      const rightData = result.right && new Int16Array(result.right.buffer, 0, result.right.byteLength / 2);
      const remaining = leftData.length + (rightData ? rightData.length : 0);

      const maxSamples = 1152;
      for (let i = 0; i < remaining; i += maxSamples) {
        const left = leftData.subarray(i, i + maxSamples);
        let right = null;
        let mp3buf = null;

        if (channels === 2) {
          right = rightData.subarray(i, i + maxSamples);
          mp3buf = mp3enc.encodeBuffer(left, right);
        } else {
          mp3buf = mp3enc.encodeBuffer(left);
        }

        if (mp3buf.length > 0) {
          buffer.push(mp3buf);
        }
      }

      const enc = mp3enc.flush();

      if (enc.length > 0) {
        buffer.push(enc);
      }

      return new Blob(buffer, { type: 'audio/mp3' });
  },
  drawCanvas:function (){
        this.drawId = requestAnimationFrame(this.drawCanvas);
        // 实时获取音频大小数据
        let datas = this.recorder.getRecordAnalyseData(),
            length = datas.length;

        // 填充背景色
        this.ctx.fillStyle = 'rgb(248, 248, 250)';
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);

        // 设定波形绘制颜色
        this.ctx.lineWidth = 2;
        this.ctx.strokeStyle = 'rgb(33, 150, 243)';

        this.ctx.beginPath();

        var sliceWidth = this.canvas.width * 1.0 / length, // 一个点占多少位置，共有bufferLength个点要绘制
            x = 0;          // 绘制点的x轴位置

        for (var i = 0; i < length; i++) {
          var v = datas[i] / 128.0;
          var y = v * this.canvas.height / 2;

          if (i === 0) {
            // 第一个点
            this.ctx.moveTo(x, y);
          } else {
            // 剩余的点
            this.ctx.lineTo(x, y);
          }
          // 依次平移，绘制所有点
          x += sliceWidth;
        }

        this.ctx.lineTo(this.canvas.width, this.canvas.height / 2);
        this.ctx.stroke();
      },
      audioCancelAction:function (){
        this.audio.isrecorder=false;
        this.audio.duration=0;
        this.recorder = null;
        this.audio.visible = false;
      },
      socketInit:function(){
        const self = this;
        if(typeof(WebSocket) == 'undefined'){
          this.$message.error({content: '浏览器不支持WebSocket.', duration: 2});
        }else{
          if ('WebSocket' in window) {
            self.createSocket();
          }else{
            this.$message.error({content: '浏览器不支持WebSocket.', duration: 2});
          }
        }
      },
      createSocket:function (){
        const self = this;
        try{
          self.socket = new WebSocket(global.wsDUrl+'?uid='+self.current.id);
          self.socket.onopen = function (event) {
            console.info('WebSocket连接建立成功.');
            if(self.heartHandler){
              window.clearTimeout(self.heartHandler);
            }
            self.heartHandler = window.setTimeout(self.heartbeat, 30000);
          };
          //接收消息监听
          self.socket.onmessage=function (event) {
            let data = event.data;
            console.log("接收到服务端数据：" + data);
            let msg = JSON.parse(data);

            if(msg.header.contentType == 'application/event'){
              if(undefined != msg.body && null != msg.body && '' != msg.body){
                let body = JSON.parse(msg.body);
                //关闭视频事件
                if(body.event === 'CLOSE_VIDEO'){
                  console.info('辅诊专家关闭音视频.');
                  self.closeVideoEvent('0');//对方关闭音视频事件处理
                }
                if(body.event === 'OPEN_VIDEO'){
                  self.$confirm({
                    title: '辅诊专家向您发起音视频通讯,是否接受?',
                    onOk() {
                      self.connectTRTC(body.payload);
                    },
                    onCancel() {
                      self.socket.send(JSON.stringify({contentType:'application/event', from:self.current.doctorId, to:self.record.expertId,
                        body:JSON.stringify({event:'CLOSE_VIDEO', payload:self.record.id}), tid:self.current.tenantId, bizId:self.record.id}));
                    }
                  });
                }
                if(body.event === 'VISITED'){
                  self.$message.info({content: '远程辅助专家已开具处方，请到门诊待收费模块进行收费操作.', duration: 2});
                }
              }else{
                console.log('WebSocket事件消息为空.');
              }
            }else{
              if(msg.bizId == self.record.id) {
                if(msg.header.contentType.startsWith('text')){
                  self.appendMsg(self.record.id, 'U', 'text', msg.body);
                }
                if(msg.header.contentType.startsWith('image')){
                  self.appendMsg(self.record.id, 'U',  'image', msg.body);
                }
                if(msg.header.contentType.startsWith('audio')){
                  self.appendMsg(self.record.id, 'U',  'audio', msg.body);
                }
              }
            }
          },
              //关闭事件监听
              this.socket.onclose = function (event) {
                console.log('WebSocket连接已关闭');
                self.reconnect();
              };
          //错误事件监听
          this.socket.onerror = function (event) {
            console.log('WebSocket发生错误');
            self.reconnect();
          };

        }catch (error) {
          console.log(error);
        }
      },
      //心跳检测
      heartbeat: function () {
        console.log('执行heartbeat socket状态:' + this.socket.readyState);
        if (this.socket && this.socket.readyState == 1) {
          this.socket.send(JSON.stringify({contentType:'application/pong', body:JSON.stringify({event:'pong'}), to:'system'}));
          console.log('发送pong完成');
        }else{
          this.reconnect();
        }
        if(this.heartHandler){
          window.clearTimeout(this.heartHandler);
        }
        this.heartHandler = window.setTimeout(this.heartbeat, 30000);
      },
      //重连函数
      reconnect:function () {
        console.log(this.socket.readyState);
        if (this.socket && this.socket.readyState == 1) {
          return;
        }
        if (this.socket){
          console.log('WebSocket先关闭');
          this.socket.close();
        }
        console.log('WebSocket再重连');
        this.createSocket();
      },
      sendMeg:function(){
        if(undefined != this.message && null != this.message && '' != this.message){
          let meet={contentType:'text/plain', from:this.current.doctorId, nickname:this.current.name,
            to:this.record.expertId, body:this.message, tid:this.current.tenantId, bizId:this.record.id};
          this.socket.send(JSON.stringify(meet));
          console.info("发送的消息内容："+JSON.stringify(meet));
          //添加消息
          this.appendMsg(this.record.id, 'I', 'text', this.message);
          this.message='';
        }
        this.$refs.send.focus();
      },
      appendMsg:function(id, sender, type, body){
        const self = this;
        if(undefined == this.chats || null == this.chats){
          this.chats=[];
        }
        this.chats.push({sender:sender, messages:[{type:type, message:body}]});
        //调整滚动条
        let containerTimer = window.setTimeout(()=>{
          self.$refs.chats.scrollTop = self.$refs.chats.scrollHeight;
          // 清理定时器
          window.clearTimeout(containerTimer);
        },10);
      },
      //音视频
      //连接音视频
      connectTRTC:function(room){
        const self = this;
        this.trtc = true;
        this.trtcClient = TRTC.createClient({mode: 'rtc', sdkAppId: this.current.videoAppId,
          userId: this.current.doctorId, userSig: this.current.userSig});
        this.trtcClient.on('stream-added', event => {
          const remoteStream = event.stream;
          //订阅远端流
          self.trtcClient.subscribe(remoteStream);
        });
        this.trtcClient.on('stream-subscribed', event => {
          const remoteStream = event.stream;
          // 播放远端流
          document.getElementById("remoteStream").innerHTML='';
          remoteStream.play('remoteStream');
        });
        this.trtcClient.join({ roomId : room }).then(() => {
          console.log('实时音视频进房成功.');
          self.localStream = TRTC.createStream({ userId: self.current.doctorId, audio: true, video: true });
          self.localStream.initialize().then(() => {
            console.log('本地音视频初始化成功.');
            self.localStream.play('localStream');//播放本地流

            self.trtcClient.publish(self.localStream).then(() => {
              console.log('本地音视频流发布成功');
            }).catch(error => {
              console.error('本地音视频流发布失败 ' + error);
            });
          }).catch(error => {
            console.error('本地音视频初始化失败 ' + error);
          });
        }).catch(error => {
          console.error('实时音视频进房失败 ' + error);
        });
      },
      //退出视频房间
      closeVideoEvent:function(source){
        const self = this;
        this.trtc =false;
        if(undefined != self.trtcClient && null != self.trtcClient){
          // 取消发布本地流
          console.info('开始取消发布本地流');
          self.trtcClient.unpublish(self.localStream).then(() => {
            console.info('取消发布本地流成功');
          });
          //关闭本地音视频
          if(undefined != self.localStream && null != self.localStream){
            console.info('开始关闭本地摄像头');
            const videoTrack = self.localStream.getVideoTrack();
            if (videoTrack) {
              self.localStream.removeTrack(videoTrack).then(() => {
              });
              videoTrack.stop();
            }
            self.localStream.muteAudio();
          }
          //退出房间
          self.trtcClient.leave().then(() => {
            console.info('关闭音频和摄像头成功');
          }).catch(error => {
            console.error('实时音视频退房失败 ' + error);
          });
        }
        this.cleanStream();
      },
      cleanStream: function () {
        if(document.getElementById('localStream')){
          document.getElementById('localStream').innerHTML = '';
        }
        if(document.getElementById('remoteStream')){
          document.getElementById('remoteStream').innerHTML = '';
        }
      },
      handleImgUpload:function(src){
        if(undefined != this.image && null != this.image && '' != this.image){
          let meet={contentType:'image/*', from:this.current.doctorId, nickname:this.current.name,
            to:this.record.expertId, body:this.image, tid:this.current.tenantId, bizId:this.record.id};
          this.socket.send(JSON.stringify(meet));
          console.info("发送的消息内容："+JSON.stringify(meet));
          //添加消息
          this.appendMsg(this.record.id, 'I', 'image', this.image);
          this.image = '';
        }
        return false;
      },
      beforeUpload:function(file){
        if(undefined != file && null != file){
          const isLt = file.size / 1024 / 1024 < 2;
          if(!isLt){
            this.$message.error({content: '图片文件大小需少于2M.', duration: 2});
            return false;
          }
          this.getBase64(file);
        }else{
          this.$message.error({content: '请先选择需要上传的图片文件.', duration: 2});
          return false;
        }
        return true;
      },
      getBase64:function(file) {
        const self = this;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          self.image = reader.result;
        };
        reader.onerror = () => {
          self.image ='';
        }
      },
      //获取预诊申请信息
      loadOutpatient:function(id){
        const self = this;
        this.loading=true;
        this.$axios.get('/api/clinic/outpatient/'+ id +'/medical').then(function (res) {
          self.loading=false;
          if (res.msg.flag == 0 && null != res.biz) {
            self.record = res.biz;
            self.annexes = res.biz.annexes||[];
            self.pics = res.biz.pics||[];
            window.setTimeout(self.socketInit(), 3000);//初始化Socket
          }
        }, function (res) {
          self.loading=false;
        });
      },
      //获取最后50条聊天记录
      loadChats:function(id){
        const self = this;
        this.chats = [];
        this.$axios.get('/api/dmz/'+ id+'/chats', {params:{size:50}}).then(function (res) {
          if (res.msg.flag == 0 && null != res.biz && res.biz.length > 0) {
            res.biz.forEach(function (item, index) {
              if(undefined != item.from && null != item.from && '' != item.from){
                let from = JSON.parse(item.from);
                if(from.uid === self.current.doctorId){
                  if(item.contentType.startsWith('text')){
                    self.appendMsg(id, 'I', 'text', item.body);
                  }
                  if(item.contentType.startsWith('image')){
                    self.appendMsg(id, 'I',  'image', item.body);
                  }
                  if(item.contentType.startsWith('audio')){
                    self.appendMsg(id, 'I', 'audio', item.body);
                  }
                }else{
                  if(item.contentType.startsWith('text')){
                    self.appendMsg(id, 'U', 'text', item.body);
                  }
                  if(item.contentType.startsWith('image')){
                    self.appendMsg(id, 'U', 'image', item.body);
                  }
                  if(item.contentType.startsWith('audio')){
                    self.appendMsg(id, 'U', 'audio', item.body);
                  }
                }
              }
            });
          }
        }, function (res) {
        });
      },
      onAudioModalAction:function (){
        this.audio.visible = true;
      },
      showFullImg:function(url){
        this.$hevueImgPreview({
          url: url,
          mainBackground: 'rgba(0, 0, 0, .5)', // 整体背景颜色
        });
      },
      endAction:function(){
        if(undefined != this.socket && null != this.socket){
          this.socket.close();
        }
        this.destroyRecorder();
        this.$router.push({ path: '/layout/outpatient/telemeds' });
      },
      resize:function(rect) {
        this.drag.vw = rect.width;
        this.drag.vh = rect.height;
        console.info('width='+rect.width+',height='+rect.height);
      },

      /**
       * 切换本地视频
       */
      videoChange:function(){
        this.videoType = this.videoType == '1' ? '2' : '1';
      },
    }
  }
</script>

<style>
  @import '../../../assets/css/chat.css';
  @import '../../../assets/css/room.css';

  .ant-tabs-small-bar .ant-tabs-nav-container{
    height: 30px !important;
  }
  .ant-tabs-small-bar .ant-tabs-nav-container .ant-tabs-tab{
    height: 30px !important;
    padding: 0 11px !important;
    line-height: 28px !important;
  }
</style>
